import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { PHONE_DISPLAY, PHONE_LINK, WHATSAPP_LINK } from "@/lib/translations";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-brand-primary text-brand-surface" data-testid="site-footer">
      <div className="container-pad py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <img
              src="/logo-light.png"
              alt="Rodríguez Tax Services logo"
              className="h-48 w-auto object-contain"
              data-testid="footer-logo"
            />
            <p className="mt-6 text-brand-surface/70 max-w-md">{t.footer.tagline}</p>
          </div>

          <div>
            <div className="overline text-brand-accent">{t.footer.links}</div>
            <ul className="mt-5 space-y-3 text-brand-surface/80 text-sm">
              <li><Link to="/" className="hover:text-brand-accent transition-colors">{t.nav.home}</Link></li>
              <li><Link to="/services" className="hover:text-brand-accent transition-colors">{t.nav.services}</Link></li>
              <li><Link to="/about" className="hover:text-brand-accent transition-colors">{t.nav.about}</Link></li>
              <li><Link to="/testimonials" className="hover:text-brand-accent transition-colors">{t.nav.testimonials}</Link></li>
              <li><Link to="/contact" className="hover:text-brand-accent transition-colors">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline text-brand-accent">{t.footer.contact}</div>
            <ul className="mt-5 space-y-3 text-brand-surface/80 text-sm">
              <li className="flex items-center gap-2">
                <Phone size={14} />
                <a href={PHONE_LINK} className="hover:text-brand-accent" data-testid="footer-phone">{PHONE_DISPLAY}</a>
              </li>
              <li className="flex items-center gap-2">
                <MessageCircle size={14} />
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:text-brand-accent" data-testid="footer-whatsapp">WhatsApp</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} />
                <a href="mailto:JulioRodríguez@rodrigueztaxservices.us" className="hover:text-brand-accent break-all" data-testid="footer-email">JulioRodríguez@rodrigueztaxservices.us</a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} />
                <span>USA · Bilingual ES/EN</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-brand-surface/15 flex flex-col sm:flex-row gap-3 sm:items-center justify-between text-xs text-brand-surface/60">
          <span>© {year} Rodríguez Tax Services. {t.footer.rights}</span>
          <span className="tracking-widest uppercase">{t.brand_tag}</span>
        </div>
      </div>
    </footer>
  );
}
